import React from 'react';
import MapSearch from '../../../element/mapsearch';
import Title from '../../../element/title';
import clone from 'clone';
import url from '../../../urlhandler/urlHandlerActions';

const $ = jQuery;
const RE = REBUILDER;

class MapFieldPreview extends React.Component {
  constructor(props) {
    super(props);
    this.handleMapSearchValue = this.handleMapSearchValue.bind(this);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    this.state = {
      'values': [],
      'options': [],
      'toogle': true,
    };
    this.changeToogle = this.changeToogle.bind(this);
  }
  componentWillReceiveProps(nextprops) {
    this.block = nextprops.block;
  }
  handleMapSearchValue(values) {
    // this.setState({ 'values': _.pluck(values, 'slug') });
    let formatedValue = '';
    for (let index = 0; index < values.length; index++) {
      if (values[index] === ',') {
        formatedValue += '--';
        index ++;
      } else if (values[index] === ' ') {
        formatedValue += '-';
      } else {
        formatedValue += values[index];
      }
    }
    url.push({
      // 'searchField': 'mapAutocomplete',
      'searchItem': 'location', // keys
      'searchType': 'globalSearch', // taxonomies or metakeys
      'searchField': 'mapField',
      values: formatedValue,
    });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  render() {
    this.helperData = clone(this.props.helperData);
    this.block = this.props.block;
    let options = [];
    let values = this.state.values;
    if (this.block.selectedDataType !== null) {
      // taxonomies
      if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
        options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
        this.searchType = 'taxonomies';
        this.searchItem = this.block.selectedTaxonomy;
      } else {
        options = this.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
        this.searchType = 'metakeys';
        this.searchItem = this.block.selectedMetakey;
      }

      // url case
      if (this.props.urlData.hasOwnProperty(this.searchItem)) {
        if (this.state.values.length < 1) {
          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
        }
      } else {
        values = [];
      }
    }
    const ifOpen = this.state.toogle ? 'active' : 'toggle-option';
    const checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
    const HelperClass = this.state.toogle ? 'single-component' : '';

    return (<div className={checkBoxClassName}>
      <Title
        title={this.props.block.title}
        subtitle={this.props.block.subtitle}
        toogle= {this.state.toogle}
        onToogle = {this.changeToogle}
        selectedToogleViewType = {this.props.block.selectedToogleViewType}
      />
      <div className={HelperClass}>
        <MapSearch block = {this.props.block} urlData={this.props.urlData} options={options} submitMapSearch={this.handleMapSearchValue} isOpenElement={ifOpen} value={values} />
      </div>
    </div>);
  }
}

MapFieldPreview.propTypes = {
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
  'helperData': React.PropTypes.object,
};

export default MapFieldPreview;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/search/default/mapfieldpreview.js
 **/